import * as classNames from 'classnames';
import * as React from 'react';
import Render from 'source/app/presentation/Shared/Render';
import * as styles from 'source/app/presentation/Shared/ActivePanel/NavigationMenu/NavigationMenuItem/NavigationMenuItem.css';
import { EBadgeColor } from 'source/app/presentation/Shared/ActivePanel/NavigationMenu/NavigationMenuItem/NavigationMenuItemBadge/EBadgeColor/EBadgeColor';

export function NavMenuItemBadge({
	badgeText,
	backgroundColor,
	isPanelActive
}: {
	badgeText: string | undefined;
	backgroundColor: EBadgeColor;
	isPanelActive: boolean;
}) {
	return (
		<Render
			id="badge"
			when={badgeText !== undefined}
			withClasses={classNames(styles.badgeDefault, {
				[styles.inactive]: !isPanelActive
			})}
			style={{ backgroundColor: EBadgeColor[backgroundColor] }}
		>
			{badgeText}
		</Render>
	);
}
